<header class="next-header"
        [ngClass]="{
            'next-header--with-title-badge': titleBadge,
            'next-header--notification': wizardService.isNotificationStep
        }"
>

  <div class="next-header__left">
    <div *ngIf="wizardService.resolveElementVisibility(logo)"
         [ngClass]="{'next-header__left__logo--anchor': logoRedirectEnabled}"
         class="next-header__left__logo">
      <img [src]="logo.url"
           width="190"
           height="37"
           alt="KioskPolis"
           (click)="navigateToLP()">
    </div>
      <div *ngIf="logosDividerVisible"
           class="next-header__left__logos-divider"
      ></div>
      <div *ngIf="additionalLogo"
           class="next-header__left__additional-logo">
          <img [src]="additionalLogo.src"
               [alt]="additionalLogo.alt">
      </div>
    <div *ngIf="dividerVisible"
         class="next-header__left__divider"
    ></div>
    <div *ngIf="title"
         class="next-header__left__title"
         [innerHTML]="title | translate | safeHtml"
    >
    </div>
      <div *ngIf="titleBadge"
           class="next-header__left__title-badge">
          <img [src]="titleBadge" alt="">
      </div>
  </div>

  <div *ngIf="navigationVisible"
       class="next-header__nav">
    <app-nav></app-nav>
  </div>

  <div *ngIf="rightContentVisible"
       class="next-header__right">
    <app-next-send-offer *ngIf="sendOfferVisible"></app-next-send-offer>

    <div *ngIf="googleReviewButtonVisible"
         class="next-header__google-review-btn">
      <div class="next-header__google-review-btn__header">
        {{ 'HEADER.SUBMIT_GOOGLE_REVIEW.HEADER' | translate }}
        <img src="assets/images/logo/google.svg" alt="Google">
      </div>
      <div class="next-header__google-review-btn__button">
        <a [href]="SUBMIT_GOOGLE_REVIEW_URL" target="_blank">
          {{ 'HEADER.SUBMIT_GOOGLE_REVIEW.BUTTON_LABEL' | translate }}
        </a>
      </div>
    </div>
  </div>
</header>
